import { isFeatureEnabled } from 'owa-feature-flags';
import { getInRibbonMode } from 'owa-command-ribbon-store';

// it is obviously important that we only render one command bar at a time
// so I am putting all the logic in one place so it makes it easy to unit test
// This function can be removed and simplified once the flights have graduated
export function shouldRenderCommanding(
    checkForRightPane?: boolean,
    checkForAppModuleRender?: boolean
): boolean {
    const hasCloseCommandBar =
        isFeatureEnabled('mon-tri-collapsibleFolderPane') ||
        isFeatureEnabled('mon-densities') ||
        getInRibbonMode();

    if (checkForRightPane) {
        // to render in the reading pane, the close command bar needs to be turned off
        return !hasCloseCommandBar;
    }

    const isSharedRibbonEnabled = isFeatureEnabled('fwk-ribbon-shared');
    if (checkForAppModuleRender) {
        // to render if the app app module, we need to have a close command bar and these two flights on
        return hasCloseCommandBar && isSharedRibbonEnabled;
    }

    // to render in MailModule on top, we need to have the close command bar and the shared ribbon off
    return hasCloseCommandBar && !isSharedRibbonEnabled;
}
